import HeroContent from "@/components/sections/hero/HeroContent";
import HeroImageCard from "@/components/sections/hero/HeroImageCard";

const BLOB_SIZE_LG = 520;
const BLOB_SIZE_SM = 400;

export default function Hero({ t, scrollTo }) {
  return (
    <section
      id="hero"
      className="relative pt-32 sm:pt-40 pb-20 sm:pb-28 overflow-hidden grain"
      data-testid="hero-section"
    >
      <div
        className="hero-blob"
        style={{ width: BLOB_SIZE_LG, height: BLOB_SIZE_LG, background: "#1995AD", top: -100, right: -120 }}
      />
      <div
        className="hero-blob"
        style={{ width: BLOB_SIZE_SM, height: BLOB_SIZE_SM, background: "#E05A33", bottom: -120, left: -120, opacity: 0.2 }}
      />

      <div className="max-w-7xl mx-auto px-6 sm:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <HeroContent t={t} scrollTo={scrollTo} />
          <div className="lg:col-span-5 reveal">
            <HeroImageCard cardTitle={t.hero.cardTitle} cardSub={t.hero.cardSub} />
          </div>
        </div>
      </div>
    </section>
  );
}
